import { AxiosResponse } from 'axios';
import { AnyObject, ResponseModel } from 'common/interfaces';
import { DeviceTypes } from './../constants';
import axiosInstance from '../shared/api/axios-instance';

export async function getVideos(
  pageUrl: string,
  deviceType: DeviceTypes
): Promise<AxiosResponse<ResponseModel<AnyObject[]>>> {
  return axiosInstance({
    method: 'POST',
    url: 'tutorial/getVideos',
    data: {
      pageUrl,
      deviceType
    }
  });
}
